export { default } from './useCoursesStatics';
